import React, { useEffect, useState } from "react";
import { ignoreHeaders } from "./tableUtils";
import { formatDate } from "../../util/util";
import ProposalHalfSolicated from "../HalfPage_Popup/ProposalHalfSolicated";
import ProposalHalfUnsolicated from "../HalfPage_Popup/ProposalHalfUnsolicated";
import InternalHalfPageBreif from "../InternalHalfPageBriefs/InternalHalfPageBriefs";
import AuditTrailComment from "../../pages/AuditTrail/AuditTrailComments";
import { useLanguage } from "../../context/Languagecontext";

const AuditTrailTable = (props) => {
  const { Globals ,languages, setLanguages } = useLanguage();
  const [isHalfScreenPopupVisible, setIsHalfScreenPopupVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedInnerTableRowData, setSelectedInnerTableRowData] = useState({});
  const [showHalfPage, setShowHalfPage] = useState(false);
  const [viewComments, setViewComments] = useState(false);
  const isFromProducerPage=JSON.parse(localStorage.getItem('isFromProducerPage'));
  const multiLang = localStorage.getItem("lang");

  useEffect(() => {
    if (isHalfScreenPopupVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isHalfScreenPopupVisible]);

  /**
     * this useEffect is to open the respective halfscreen with thr req params when nav back form producers page
     */
    useEffect(()=>{
      if(isFromProducerPage){
      handleClick(localStorage.getItem('propIndex'))
      localStorage.setItem('isFromProducerPage',false)
    }
    },[isFromProducerPage])

  if (!props.data || props.data.length === 0) {
    return <p>No data available</p>;
  }

  const handleSort = (event) => {
    const newSortKey = props.sortKey === 1 ? 0 : 1;
    props.onSort(newSortKey);
  };

  const handleClick = (item) => {
    localStorage.setItem('propIndex',item);
    let data = props.data[item];
    const transformedData = {
      applicationDate: data?.actionDate,
      assignedUsers: data?.actionBy,
      auditrailAction : data?.actionName.statusName,
      producer: data?.producer,
      producerId: data?.producerId,
      propRefNo: data?.propRefNo,
      proposalDetailId: data?.proposalDetailId,
      proposalId: data?.proposalId,
      proposalTitle: data?.title ? data?.title : data?.propRefNo,
      proposalType: data?.proposalType,
    };
    setShowHalfPage(true);
    setIsHalfScreenPopupVisible(!isHalfScreenPopupVisible);
    setSelectedItem(transformedData);
    setSelectedInnerTableRowData(transformedData);
  };

  const handleCloseHalfPage = () => {
    setIsHalfScreenPopupVisible(false);
    setSelectedItem(null);
  };

  const handleBriefClick = (item) => {
    let data = props?.data[item];
    const transformedBreifData = {
      closingDate: data?.actionDate,
      assignedUsers: data?.actionBy,
      producer: data?.producer,
      producerId: data?.producerId,
      bRefNo: data?.bRefNo,
      proposalDetailId: data?.proposalDetailId,
      proposalId: data?.proposalId,
      proposalTitle: data?.title,
    };
    setShowHalfPage(true);
    setIsHalfScreenPopupVisible(!isHalfScreenPopupVisible);
    setSelectedItem(transformedBreifData);
    setSelectedInnerTableRowData(transformedBreifData);
  };

  const viewComment = (item) => {
    let itemValue = props?.data[item];
    setViewComments(true);
    setSelectedItem(itemValue);
  };

  const handleCloseComment = () => {
    setViewComments(false);
    setSelectedItem(null);
  };

  let headers = ignoreHeaders(props?.data);

  return (
    <>
      <table>
        <thead>
          <tr>
            {headers.map((header, index) => {
              if (header === "propRefNo") {
                return (
                  <th key={header} className={`AuditTrail-header thProposalNo thaudittrail-${multiLang}`}>
                    {Globals.TABLE_HEADERS.PROPOSALNO}
                  </th>
                );
              }
              if (header === "bRefNo") {
                return (
                  <th key={header} className={`AuditTrail-header thbriefno thaudittrail-${multiLang}`}>
                    {Globals.TABLE_HEADERS.BRIEFNO}
                  </th>
                );
              }
              if (header === "producer") {
                return (
                  <th key={header} className={`AuditTrail-header thproducer thaudittrail-${multiLang}`}>
                  {Globals.TABLE_HEADERS.PRODUCER}
                  </th>
                );
              }
              if (header === "title") {
                return (
                  <th key={header} className={`AuditTrail-header thtitle thaudittrail-${multiLang}`}>
                  {Globals.TABLE_HEADERS.PROPOSALTITLE}
                  </th>
                );
              }
              if (header === "actionBy") {
                return (
                  <th key={header} className={`AuditTrail-header thactionby thaudittrail-${multiLang}`}>
                    {Globals.TABLE_HEADERS.ACTIONBY}
                  </th>
                );
              }
              if (header === "actionName") {
                return (
                  <th key={header} className={`AuditTrail-header thaction thaudittrail-${multiLang}`}>
                    {Globals.TABLE_HEADERS.ACTION}
                  </th>
                );
              }

              if (header === "actionDate") {
                return (
                  <th
                    key={index}
                    className={`AuditTrail-header thactiondate thaudittrail-${multiLang}`}
                    onClick={(e) => handleSort(e)}
                  >
                     {Globals.TABLE_HEADERS.ACTIONDATE}
                    <img
                      src={
                        props.sortKey === 1
                          ? Globals.IMG.ARROW_DOWN_ICON
                          : Globals.IMG.ARROW_UP_ICON
                      }
                      alt="info icon"
                      className="icon-style arrowimg_date"
                      onClick={(e) => handleSort(e)}
                    />
                  </th>
                );
              }

              if (header === "comment") {
                return (
                  <th key={header} className={`AuditTrail-header thcomment thaudittrail-${multiLang}`}>
                    {Globals.TABLE_HEADERS.COMMENTIFANY}
                  </th>
                );
              }
            })}
            <th className={`AuditTrail-header thCheck thaudittrail-${multiLang}`}></th>
          </tr>
        </thead>
        <tbody>
          {props.data.map((row, rowIndex) => (
            <tr key={rowIndex}
            onClick={() =>
              props?.activeTab === "Proposal Audit Trail"
                ? handleClick(rowIndex)
                : handleBriefClick(rowIndex)
            }>
              {headers
                .filter((header) => row[header] !== undefined)
                .map((header) => (
                  <td className="auditRaildata" key={header}>
                    {row[header] !== null && row[header] !== "" ? (
                      header === "propRefNo" ? (
                        <>{row[header] ? row[header] : "N/A"}</>
                      ) : header === "producer" ? (
                        <>{row[header] ? row[header] : "N/A"}</>
                      ) : header === "title" ? (
                        <div className="td-proposal-title">{row[header]}</div>
                      ) : header === "actionBy" ? (
                        <div className="td-action-by">{row[header]}</div>
                      ) : header === "actionName" ? (
                        props.activeTab === "Proposal Audit Trail" ? (
                          <div className="td-action-name">{row[header].statusName}</div>
                        ) : (
                          <div>{row[header]}</div>
                        )
                      ) : header === "actionDate" ? (
                        <div>{formatDate(row[header])}</div>
                      ) : header === "comment" ? (
                        <div
                          className="viewComment"
                          onClick={(event) => {
                            event.stopPropagation();
                            viewComment(rowIndex);
                          }}
                          onClose={(event) => {
                            event.stopPropagation();
                            handleCloseComment();
                          }}
                        >
                         {Globals.TABLE_HEADERS.VIEWCOMMENTS}
                        </div>
                      ) : (
                        row[header]
                      )
                    ) : header === "comment" ? (
                      ""
                    ) : (
                      "N/A"
                    )}
                  </td>
                ))}
              <td className="BlankColumn auditRaildata">
                <div
                  className="Openpoposal"
                  onClick={() =>
                    props?.activeTab === "Proposal Audit Trail"
                      ? handleClick(rowIndex)
                      : handleBriefClick(rowIndex)
                  }
                >
                  <img src={Globals.IMG.VIEW} width={20} height={20} className="cursor" />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div>
        {isHalfScreenPopupVisible && showHalfPage && selectedItem && (
          <div className="overlay">
            <div className="popup">
              {props?.activeTab === "Proposal Audit Trail" ? (
                selectedItem?.proposalType === 1 ? (
                  <ProposalHalfUnsolicated
                    item={selectedItem}
                    onClose={handleCloseHalfPage}
                    popupShow={false}
                    refreshDashboard={null}
                    renderToast={props.renderToast}
                    proposalDetailIdVal={selectedItem?.proposalDetailId}
                    isAuditTrail={true}
                    page={props.currentPage}
                  />
                ) : (
                  <ProposalHalfSolicated
                    item={selectedItem}
                    onClose={handleCloseHalfPage}
                    selectedInnerTableRowData={selectedInnerTableRowData}
                    popupShow={false}
                    isAuditTrail={true}
                    page={props.currentPage}
                  />
                )
              ) : (
                <InternalHalfPageBreif
                  item={selectedItem}
                  onClose={handleCloseHalfPage}
                  proposalIds={selectedItem}
                  popupShow={props.popupShow}
                  selectedCluster={props.ClusterInfo}
                  isAudiTrail={true}
                />
              )}
            </div>
          </div>
        )}
        {viewComments && (
          <AuditTrailComment
            isOpen={viewComments}
            itemValue={selectedItem}
            selectedTab={props.activeTab}
            onClose={handleCloseComment}
          />
        )}
      </div>
    </>
  );
};

export default AuditTrailTable;
